import React from 'react'

function IconHome() {
  return (
    <svg focusable="false" aria-hidden="true" className="icon icon--home">
      <use xlinkHref="#icon-home" />
    </svg>
  )
}

export default IconHome
